
// USA
export const locale = {
  lang: 'en',
  data: {
    mare: 'mare',
    gelding: 'gelding',
    stallion: 'stallion',
    maintenance: {
      title: 'Maintenance',
      message:
        'Our website is currently undergoing maintenance. Please visit again later. Thank you for your understanding.',
    },
    STREAMING: {
      DIAGNOSTICS: 'Playback diagnostics',
      COPY_DIAGNOSTICS: 'Copy diagnostics',
      DIAGNOSTICS_HELP: 'If automatic copying fails, select and copy the text below. Nothing is sent automatically.',
      RECONNECTING: 'Reconnecting…',
      PAUSE: 'Pause',
      RESUME: 'Resume',
      TAP_TO_PLAY: 'Tap to play',

      RACE_FINISHED: 'Finished',
      COVERAGE: 'Coverage',
      SHOW: 'Show',
      HIDE: 'Hide',
      OTHER_STREAMS: 'Other streams',
      CHOOSE_TRACK: 'Choose a live stream',
      CHANNEL_NUMBER: 'Channel {{number}}',
      IN_MINUTES: 'in {{minutes}} min',
      AT_TIME: 'at {{time}}',
      AT_POST: 'At post',
      LIVE: 'Live',
      FINISHED: 'Finished',
      SHORT_UNAVAILABLE: 'Unavailable',
      SCHEDULE_PENDING: 'Time pending',

      BROWSER_UNSUPPORTED: 'This browser cannot play this stream. Try another browser or choose PMU TV.',
      QUINTE: 'Quinté+',
      GUIDE: 'Live from the racecourses',
      VIDEO: 'Horse racing live video',
      CHANNEL: 'Choose channel',
      PMU: 'PMU TV',
      BACK_TO_PMU: 'Watch PMU TV',
      CONNECTING: 'Connecting to the stream…',
      LOADING: 'Loading today’s reunions…',
      UPDATED: 'Updated',
      RETRY: 'Retry',
      STALE: 'Schedule update delayed.',
      GUIDE_ERROR: 'Track list unavailable. PMU TV remains available.',
      DISABLED: 'Reunion streams are temporarily unavailable.',
      EMPTY: 'No reunion streams are scheduled yet.',
      PLAYBACK_ERROR: 'This stream is temporarily unavailable. Retry or choose another channel.',
      ACCESS_ERROR: 'Your streaming session is no longer available. Sign in again or choose PMU TV.',
      REUNION_SHORT: 'R',
      RACE_SHORT: 'C',
      PHASE_live: 'Live · estimated',
      PHASE_onair: 'On air',
      PHASE_upcoming: 'Upcoming',
      PHASE_ended: 'Ended',
      PHASE_unknown: 'Schedule pending',
      STARTS_IN: 'Starts in',
      ESTIMATED: 'Estimated schedule',
      SHARED_SIGNAL: 'Signal shared with {{meeting}}',
      UNAVAILABLE: 'Stream unavailable',
      SELECTION_CHANGED: 'This meeting is no longer in the programme.',
      SCHEDULE_NOTE: 'Times and race indicators are estimates for the video guide. Refer to the race page for betting status.',
    },
    GENERAL: {
      RACES: 'Races',
      DELETE: 'Delete',
      ONE_MOMENT: 'One moment please...',
      CLOSE: 'Close',
      PRINT: 'Print',
      CONFIRM: 'Confirm',
      CANCEL: 'Cancel',
      RESULT: 'Result',
      TEMPORARY_RESULT: 'Temporary Result',
      SELECT: 'Select your language',
      LANGUAGE: 'Language',
      PLEASE_KEEP_THESE_INFORMATION_SAFE: 'Please keep this information safe',
    },
    MENU: {
      HOME: 'HOME',
      ALL_RACES: 'ALL RACES',
      ALL_RACES_SHORT: 'ALL',
      PMU_RACES: 'PMU RACES',
      PMU_RACES_SHORT: 'PMU',
      NEXT_RACES: 'NEXT RACES',
      NEXT_RACES_SHORT: 'NEXT',
      STREAMING: 'Live Streaming',
      BET_TYPES: 'Bet types',
      DEPOSIT_WITHDRAWAL: 'Deposits & withdrawals',
      TERMS: 'Terms & conditions',
      CONTACT: 'Contact',
      VIRTUALS: 'VIRTUAL',
    },
    VIRTUALS: {
      TITLE: 'Golden Race',
      OPENING: 'Opening Golden Race…',
      LEAVING: 'Closing Golden Race…',
      RETRY: 'Retry',
      LOADING: 'Loading the game…',
      RECONNECTING: 'Reconnecting…',
      UNAVAILABLE: 'Golden Race is temporarily unavailable. Please try again in a moment.',
      ERROR: 'The game could not be started. Please try again in a moment.',
      CONFIG_ERROR: 'Golden Race is not available right now. Our team has been notified.',
      CURRENCY_UNSUPPORTED:
        "Golden Race is not yet available for your account's currency.",
      NOT_ENABLED: 'Golden Race is not yet available for your account.',
      DEPOSIT_ERROR:
        'The deposit window could not be opened. Please try again, or use the Deposit button at the top of the page.',
    },
    SUPPORT: {
      TITLE: 'Support',
      LIVE_CHAT: 'Live Chat',
      MESSAGE: 'Message',
      HELP: 'Help',
      UNAVAILABLE: 'Support chat is currently unavailable. Please try again later.',
    },
    BETTING_SLIP: {
      YOUR_BETTING_SLIP: 'Your Betting Slip',
    },
    HOME: {
      CALENDAR: 'Calendar',
      TODAY: 'Today',
      YESTERDAY: 'Yesterday',
      TOMORROW: 'Tomorrow',
      COUNTRIES: 'Countries',
      NEXT_BETTING: 'Next betting opportunities',
      NEXT_PMU_BETTING: 'PMU next races',
      MORE: 'MORE',
      JACKPOT: 'Jackpot',
      ACCUMULATOR_TITLE: 'Bet Box/accumulator bet',
      ACCUMULATOR_DESC:
        'No horse selected for the accumulator bet. Click on the tote odds in the race.',
      STARTER_SEARCH: 'Starter search',
      SEARCH: 'Search',
      HEAD_TO_HEAD: 'Head to Head',
      HEAD_TO_HEAD_DESC: 'There are no Head to Head pairings available today.',
      HIGHLIGHTS: 'Highlights',
      STARTER_INDEX: 'Starter index',
      LOGIN: 'LOG IN | REGISTER',
      LOGIN_SHORT: 'LOG IN',
      LOGIN_BUTTON_MODAL: 'LOG IN',
      LOGOUT: 'Logout',
      STARTING: 'Starting...',
      STARTING_SHORT: 'Starting...',
      IN: 'in',
      MAINTANANCE:
        'OUR PLATFORM WILL BE UNAVAILABLE ON TUESDAY, 08/11/2022, BETWEEN 23:00 - 02:00 CEST DUE TO MAINTENANCE',
      NOT_SHOW: 'Not show again.',
    },
    RACES: {
      WAITING_FOR_APPROVE: 'Waiting for approve',
      MANUALREVIEW: 'Manual Review',
      CANCELREASON: 'Cancel Reason',
      COMBINAISON: 'Combination',
      PRIZE_MONEY: 'Prize Money',
      DISTANCE: 'Distance',
      SOIL: 'Soil',
      STARTERS: 'Starters',
      RESULT: 'Result',
      STARTED: 'Started',
      BETTING_SLIP: 'Betting slip',
      START_TYPE: 'Start type',
      NON_STARTERS: 'Non-starters',
      TYPE_OF_BET: 'Type of Bet',
      STAKES: 'Stakes',
      KEYPAD_DONE: 'Done',
      STAKE: 'Stake',
      TIME_RACE: 'Time/Race',
      MARKINGS: 'Markings',
      EV: 'EV',
      WIN: 'Win',
      BET: 'Bet',
      NEW: 'New',
      NUMBER_OF_BETS: 'Number of bets',
      PLACE_BET: 'Place Bet',
      PLACE_BET_PRINT: 'Place Bet',
      PAY_FOR_BET: 'Pay for Bet',
      CONFIRM_TEXT: 'The total cost of this bet is',
      POTENTIAL_WINNINGS: 'Potential winnings',
      TOTAL_STAKES: 'Total Stakes',
      TOTAL_PRICE: 'Total Price',
      STAKES_IN: 'Stakes in',
      RACING_CLUB: 'Racing Club',
      MORE_BOOKIE_BETS: 'More Bookie Bets',
      BOOKMAKER: 'Bookmaker',
      FIXED_ODDS_BET: 'Fixed-odds bet',
      SHOW_BETTING_SLIP: 'Show betting slip',
      HIDE_BETTING_SLIP: 'Hide betting slip',
      MY_BETS: 'My Bets',
      WINNINGS: 'Winnings',
      TOP_WINNINGS: 'Winnings',
      NUMBER: 'Number',
      OPEN: 'Open',
      LOST: 'Lost',
      WON: 'Won',
      CANCELED: 'Canceled',
      REFUND: 'Refund',
      CANCEL: 'Cancelled',
      CANCEL_BUTTON: 'Cancel',
      CASHBACK: 'Cashback',
      STATUS: 'Status',
      HORSE: 'Horse',
      FORM: 'Form',
      WEIGHT: 'Weight',
      TRAINER: 'Trainer',
      SP: 'SP',
      FIXED_ODDS: 'Fixed Odds',
      ORIGIN: 'Origin',
      LINEAGE: 'Lineage',
      OWNER: 'Owner',
      AGE: 'Age',
      JOCKEY: 'Jockey',
      PLACE: 'Place',
      TOTAL: 'Total',
      TOTAL_WON: 'Total Won',
      TOTAL_LOST: 'Total Lost',
      TOTAL_BETS: 'Total Bets',
      TOTAL_CANCELED: 'Total Canceled',
      TOTAL_REFUND: 'Total Refund',
      TOTAL_CASHBACK: 'Total Cashback',
      DATE: 'Date',
      RACE: 'Race',
      RACE_C: 'Race',
      RACE_LOCATION: 'Race Location',
      BET_TYPES: 'Bet types',
      CONFIRM_YOUR_BET: 'Confirm Your Bet',
      GO_TO_RACE: 'Go to Race',
      DOG: 'Dog',
      DRIVER: 'Driver',
      RECORD_TIME: 'Record time',
      NO_OF_STARTS: 'No. of starts',
      NO_OF_WINS: 'No. of wins',
      NO_OF_PLACES: 'No. of places',
      QUINELLA: 'Quinella',
      SWINGER: 'Swinger',
      QUINELLA_SWINGER: 'Quinella/Swinger',
      EXACTA: 'Exacta',
      QUINTE: 'Quinte+ Champ',
      'QUINTÉ+': 'Quinte+',
      'QUINTÉ+_7': 'Quinte Order',
      'QUINTÉ+_6': 'Quinte Disorder',
      'QUINTÉ+_4': 'Quinte Order',
      'QUINTÉ+_3': 'Quinte Order',
      'QUINTÉ+_2': 'Quinte Disorder',
      'QUINTÉ+_1': 'Quinte Bonus 4',
      'QUINTÉ+_0': 'Quinte Bonus 3',
      QUINTE_STANDARD: 'Quinte Standard',
      TRIFECTA: 'Trifecta',
      TIERCE: 'Tiercé Champ',
      'TIERCÉ_-1': 'Tiercé Order',
      TIERCÉ: 'Tiercé',
      TIERCÉ_1: 'Tiercé Order',
      TIERCÉ_0: 'Tiercé Disorder',
      'TIERCÉ CHAMP_0': 'Tiercé Disorder',
      'TIERCÉ CHAMP_1': 'Tiercé Order',
      TIERCE_STANDARD: 'Tiercé Standard',
      'TIERCÉ STANDARD': 'Tiercé Standard',
      QUARTE: 'Quarté Champ',
      // 'QUARTÉ+': 'Quarté+',
      'QUARTÉ+_-1': 'Quarté Order',
      'QUARTÉ+_2': 'Quarté Order',
      'QUARTÉ+_1': 'Quarté Disorder',
      'QUARTÉ+_0': 'Quarté Bonus',
      'QUARTÉ+ CHAMP_0': 'Quarté Bonus',
      'QUARTÉ+ CHAMP_1': 'Quarté Disorder',
      'QUARTÉ+ CHAMP_2': 'Quarté Order',
      QUARTE_STANDARD: 'Quarté Standard',
      DEAD_HEAT: 'dead heat',
      // 'QUARTÉ+ STANDARD': 'Quarté Standard',
      WIN_PLACE: 'Win/Place',
      AMOUNT: 'Amount',
      BALANCE: 'Balance',
      PROFIT_FROM_BETTING: 'Profit from betting',
      TRANSACTION_DETAILS: 'Transaction Details',
      TRANSACTION_TYPE: 'Transaction Type',
      PAY_ADDRESS: 'Payment Address',
      APPLIED_AMOUNT: 'Applied Amount',
      OUTCOME_AMOUNT: 'Outcome Amount',
      WAITING: 'Waiting',
      CREATING: 'Creating',
      PROCESSING: 'Processing',
      CONFIRMING: 'Confirming',
      CONFIRMED: 'Confirmed',
      SENDING: 'Sending',
      PARTIALLY_PAID: 'Partially paid',
      FINISHED: 'Finished',
      FAILED: 'Failed',
      REJECTED: 'Rejected',
      REJECTED_NOT_CHECKED: 'Rejected not checked',
      REFUNDED: 'Refunded',
      EXPIRED: 'Expired',
      CANCELED_BY_USER: 'Canceled by user',
      DEPOSIT: 'Deposit',
      WITHDRAWAL: 'Withdrawal',
      SELECT_COUNTRY: 'Select Country',
      SELECT_CURRENCY: 'Select Currency',
      FINISH: 'Finish',
      RACE_NR: 'Race Nr.',
      RACE_NR_C: 'Race Nr.',
      ODDS: 'Odds',
      R: 'R',
      ALL: 'All',
      CANCELLATIONS: 'Cancellations',
      BETS: 'Bets',
      NOT_FOUND_RACE: 'Race not found.',
      CURRENT_FIXED_ODDS: 'Current fixed odds',
      J: 'J.',
      MARE: 'mare',
      STALLION: 'stallion',
      GELDING: 'gelding',
      T: 'E',
      NO_BET: 'You have not bet on this race yet',
      CANCEL_COUPON: 'Cancel Coupon',
      COUPON_CANCELLED_MESSAGE:
        '{{betSlipId}} coupon has been successfully canceled',
      COUPON_CANCELLED_ERROR_MESSAGE:
        'Coupon cancellation limit has been exceeded',
      SHOW_CHAT: 'Show Chat',
      HIDE_CHAT: 'Hide Chat',
      STARTING: 'Starting',
      REJECT_REASON: 'Reject Reason',
    },
    HISTORY: {
      PRODUCTS: 'Products',
      ALL: 'All',
      HORSE: 'Races',
      VIRTUAL: 'Virtual',
      STAKE_VIRTUAL: 'Stake · Virtual',
      WIN_VIRTUAL: 'Win · Virtual',
      CANCELLATION: 'Cancellation',
      CLAWBACK: 'Win reversal',
      BONUS: 'Bonus',
      VOID: 'Cancelled',
      CASHED_OUT: 'Cashed out',
      TICKET: 'Ticket',
      GAME: 'Game',
      EVENT: 'Event',
      PLACED_AT: 'Placed on',
      SETTLED_AT: 'Settled on',
      SELECTIONS: 'Selections',
      SELECTION_COUNT: '{{n}} selection(s)',
      MARKET: 'Market',
      PICK: 'Pick',
      ODDS: 'Odds',
      STAKE: 'Stake',
      WIN: 'Win',
      MOVEMENTS: 'Movements',
      REVERSED: 'reversed',
      BALANCE_AFTER: 'Balance after',
      RESULT_IN_GAME: 'Result: in the game',
      OPEN_GOLDEN_RACE: 'Open Golden Race',
      DETAILS_UNAVAILABLE: 'Details unavailable',
      KIND_HORSE: 'Horses',
      KIND_DOG: 'Greyhounds',
      KIND_FOOTBALL: 'Football',
      KIND_KENO: 'Keno',
      KIND_NUMBERS: 'Numbers',
      KIND_SPIN2WIN: 'Spin2Win',
      KIND_INSTANT: 'Instant',
      KIND_CHAMPIONS: 'Champions',
      CATEGORY_BET: 'Stake',
      CATEGORY_WIN: 'Win',
      CATEGORY_JACKPOT: 'Jackpot',
      CATEGORY_CASHOUT: 'Cash-out',
      CATEGORY_BONUS: 'Bonus',
      CATEGORY_ROLLBACK: 'Cancellation',
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
        MY_ACCOUNT: 'My Account',
      },
      MENU: {
        ACCOUNT: 'Account',
        BETS: 'Bets',
        PROFILE: 'Profile',
      },
      ACCOUNT: {
        TRANSACTION: 'Transactions',
        CRYPTO_TRANSACTION: 'Crypto Transactions',
        YOUR_CURRENT_ACCOUNT: 'Your current account status as of {{date}}',
        RECENT_TRANSACTIONS: 'Recent transactions on your betting account.',
        AVAILABLE_FOR_WITHDRAWAL: 'Available for withdrawal',
        ANY_TRANSACTION: 'You do not have any transaction.',
      },
      BET: {
        NO_BET_HISTORY: 'No bet history currently available.',
      },
      ACTIVATION: {
        TITLE: 'Activation Complete',
        PASSWORD_REQUIRED: 'You are required to change the password.',
        EMAIL_OPTIONAL:
          'Email address is optional, but we strongly recommend that you enter and activate the email you actively use. ',
        COMPLETE: 'Complete',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        FORGOT_PASSWORD: 'Forgot password?',
        RESET_PASSWORD: 'RESET PASSWORD',
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
        TEMPORARILY_LIMITED:
          'An account was recently created from this device or network. You can create a new one at {{time}} (in {{minutes}} min).',
        TEMPORARILY_LIMITED_HELPER:
          'Just registered and lost your credentials? Log in with the file or image you saved.',
        CREATE_BUTTON: 'CREATE ACCOUNT',
        FIRSTNAME: 'First name',
        LASTNAME: 'Last name',
        EMAIL_OPTIONAL: 'Email (optional)',
        EMAIL_INVALID: 'Enter a valid email address.',
        EMAIL_TAKEN: 'This email is already in use.',
        PHONE: 'Mobile number',
        PHONE_PLACEHOLDER: 'e.g. 21612345',
        PHONE_INVALID: 'Enter 6-15 digits (optionally starting with +).',
        DOB: 'Date of birth',
        DAY: 'Day',
        MONTH: 'Month',
        YEAR: 'Year',
        DOB_INVALID: 'This date does not exist — check the day and month.',
        DOB_HINT: 'You must be at least 18 years old.',
        UNDERAGE: 'You must be at least 18 years old to register.',
        MONTH_1: 'January',
        MONTH_2: 'February',
        MONTH_3: 'March',
        MONTH_4: 'April',
        MONTH_5: 'May',
        MONTH_6: 'June',
        MONTH_7: 'July',
        MONTH_8: 'August',
        MONTH_9: 'September',
        MONTH_10: 'October',
        MONTH_11: 'November',
        MONTH_12: 'December',
        USERNAME_PATTERN:
          'Only letters, numbers, dots, dashes and underscores.',
        USERNAME_TAKEN: 'This username is already taken.',
        PASSWORD_MIN: 'Password must be at least 8 characters.',
        CREATING_TITLE: 'Creating your account…',
        CREATING_SUB: 'Just a moment — signing you in automatically.',
      },
      WELCOME: {
        TITLE: 'Welcome to Racebet365!',
        BODY: 'Your account is ready. Make your first deposit and start betting on today\u2019s races.',
        CREDS_TITLE: 'Your account is ready!',
        CREDS_SUB: 'Save your login details now — you will need them to sign in next time.',
        SAVE_FILE: 'Save to file',
        SAVE_PICTURE: 'Save to picture',
        DEPOSIT_NOW: 'Deposit now',
        CLOSE: 'Close',
      },
      INPUT: {
        USERNAME: 'Username',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        NEW_PASSWORD: 'New Password',
        CONFIRM_NEW_PASSWORD: 'Confirm New Password',
        EMAIL: 'Email Address',
        CONFIRM_EMAIL: 'Confirm Email Address',
      },
      VALIDATION: {
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        PASSWORD_WEAK: 'Password is too weak: at least 8 characters, not a common password, not a repeated or sequential pattern, and not your username.',
        MIN_AMOUNT_ERROR: 'Minimum amount is {{min}} {{currency}}',
        MAX_AMOUNT_ERROR: 'Maximum amount is {{max}} {{currency}}',
      },
    },
    ALERT: {
      SUCCESSFULLY_CREATED: 'The bet has been successfully created',
      USERNAME_NOTFOUND: 'Username not found',
      USERNAME_OR_PASSWORD_IS_INCORRECT:
        'Something went wrong, The username or password is incorrect. Please try again.',
      PASSWORD_IS_INCORRECT: 'The password is incorrect. Please try again.',
      PASSWORD_MUST_MATCH: 'Passwords must match.',
      ONLY_VALID_BETS_ARE_ALLOWED: 'Only valid bets are allowed',
      RACE_IS_STARTED: 'Race is started',
      STAKE_ERROR: 'Stake error',
      INSUFFICIENT_BALANCE: 'Insufficient balance',
      USER_ACCOUNT_UPDATED: 'User account has been successfully updated',
      SOMETHING_WENT_WRONG: 'Something went wrong',
      CONFIRM_ACTION: 'Are you sure you want to proceed?',
      CONFIRM_CANCEL_WITHDRAWAL:
        'Are you sure you want to cancel this withdrawal?',
      TRANSACTION_ID_NOT_FOUND:
        'Transaction ID not found. Please contact the backend team.',
      USER_CREDENTIALS_SAVED: 'User credentials saved as image successfully',
      USER_PASSWORD_UPDATED: 'User password has been successfully updated',
      PASSWORD_SUCCESSFULLY_RESET: 'Your password was successfully reset',
      ACTIVATION_SUCCESSFULLY_COMPLETE_EMAIL:
        'User activation has been successfully complete. Please verify your email address',
      ACTIVATION_SUCCESSFULLY_COMPLETE:
        'User activation has been successfully complete',
      MUST_BE_FILLED_CORRECTLY: '{{invalids}} must be filled correctly!',
      VERIFY_YOUR_EMAIL: 'Please verify your email address',
      WELCOME: 'Welcome',
      EMAIL_SUCCESSFULLY_VERIFIED: 'Your email was successfully verified.',
      MONEY_HAS_BEEN_DEPOSITED: 'Money has been deposited into your account.',
      Please_refresh_the_page_to_print: 'Please refresh the page to print',
      INVALID_PHONE: 'Invalid Phone number',
      OUT_OF_ORDER: 'Your account has been temporarily disabled.',
    },
    QUARTE_RACES: {
      HEADER_TITLE: "Today's Quarté races",
      FINISHED: 'Finished',
      NO_RACE: 'Does not exist yet',
    },
    TRACK_RACES: {
      YEARS_OLD_HORSES: 'For {{year}} years old Horses',
      YEARS_OLD_AND_UPWARD_HORSES: 'For {{year}} years old and upward Horses',
    },

    Next_Races_Seo: {
      title: 'Next Races | Horse Racing Betting | Bet Online with Racebet365',
      description_content:
        "Don't miss the next race on Racebet365! With our 24/7 betting, you can keep up with races worldwide and place your bets on your favorite races.",
      keywords_content:
        'next race, races, Racebet365, betting, worldwide, 24/7, keeping up, favorite races.',
    },

    HomePage_Seo: {
      title: 'Horse Racing Betting | Bet Online with Racebet365',
      description_content:
        'The ultimate online destination for horse race betting around the world! Wide range of bet types for horse racing events. Pay with crypto: USDT, BTC, ETH. Join Racebet365.com today!',
      keywords_content:
        'Online horse race betting, Bet on horse races, Online betting site, Horse race gambling, Worldwide horse racing, PMU Races, crypto betting, USDT, Bitcoin, Ethereum',
    },

    All_Races_Seo: {
      title: 'All Races | Horse Racing Betting | Bet Online with Racebet365',
      description_content:
        'Discover all races worldwide and place your bets on Racebet365! We offer a wide selection from horse racing to dog racing.',
      keywords_content:
        'races, horse racing, dog racing, Racebet365, betting, UK, USA, Australia, popular races, combinations.',
    },

    Pmu_Races_Seo: {
      title: 'PMU Races | Horse Racing Betting | Bet Online with Racebet365',
      description_content:
        'Explore PMU races and place your bets on Racebet365! Exciting races await you with betting combinations like Win, Place, Ita, Trita, Jumele, Exacta, Trio, Trifecta, Tierce, and Quatre.',
      keywords_content:
        'PMU, race, Racebet365, betting, Gagnant, Place, Ita, Trita, Jumele, Exacta, Trio, Trifecta, Tierce, Quatre.',
    },

    Next_Betting_Seo: {
      description_content: 'Find the list of the next races available...',
      keywords_content: ' NEXT BETTING OPPORTUNITY',
    },

    Track_Races_Seo: {
      description_content: ' Find the list of races available in Vincennes',
      keywords_content: 'VINCENNES RACES 06/29/2022',
    },

    Account_Page_Seo: {
      description_content: 'View your transaction history',
      keywords_content: 'TRANSACTION HISTORY',
    },

    Profile_Page_Seo: {
      description_content: 'Check your account information, change password.',
      keywords_content: 'MY PROFILE',
    },

    Bets_Page_Seo: {
      description_content: 'View your betting history',
      keywords_content: 'HISTORY OF BETS',
    },
    'Some coupons gave an error': 'Some coupons gave an error',
    'Something went wrong.': 'Something went wrong.',
    'Only valid bets are allowed': 'Only valid bets are allowed',
    'Total price error': 'Total price error',
    'Coupon was lost.': 'Coupon was lost.',
    'Insufficient balance': 'Insufficient balance',
    CRYPTO: {
      MIN_WITHDRAWAL_AMOUNT_NOTE: 'Minimum withdrawal amount {{amount}} {{currency}}',
      WILL_BE_ADDED_TO_YOUR_ACCOUNT: 'Will be added to your account',
      YOU_WILL_RECEIVE: 'You will receive',
      COUNRY: 'Country',
      CURRENCY: 'Currency',
      CRYPTO_WITHDRAWAL_SUCCESSFULLY_CREATED:
        'Crypto withdrawal has been successfully created',
      SELECT_YOUR_CRYPTO_CURRENCY_WITHDRAWAL_METHOD:
        'Select your crypto currency withdrawal method',
      CONFIRM_WITHDRAWAL: 'Confirm Withdrawal',
      CONFIRM: 'Confirm',
      WITHDRAWAL_AMOUNT: 'Amount ({{currency}})',
      AMOUNT_MIN_MAX: 'Min Amount: {{min}} {{currency}}',
      YOUR_CRYPTO_ADDRESS: 'Your Crypto address',
      PLEASE_NOTE_DIFFER_SLIGHTLY_FROM_THE_ABOVE:
        'Please note that the exchange rate at the completion of the transaction may differ slightly from the above.',
      PLEASE_NOTE_THAT_PROCESSING_YOUR_WITHDRAWAL_MAY_TAKE_UP_TO_30_MINUTES:
        'Please note that processing your withdrawal may take up to 30 minutes.',
      ONLY_SEND_TETHER_USDT: 'ONLY send Tether (USDT)',
      ONLY_WITHDRAW_TETHER_USDT: 'ONLY withdraw Tether (USDT)',
      TO_THIS_DEPOSIT_ADDRESS: 'to this deposit address',
      DO_NOT_USE: 'Do NOT use',
      DO_NOT_USE_ERC20:
        'ERC20, BEP2, BEP20, OMNI, SOL, or other network standards as you may lose your deposit.',
      ONLY_MAKE_DEPOSITS_THROUGH_THE_ETHEREUM_NETWORK_ERC20:
        'ONLY make deposits through the Ethereum (ERC20) network',
      ONLY_MAKE_DEPOSITS_THROUGH_THE_ETHEREUM_NETWORK:
        'ONLY make deposits through the Ethereum network',
      ONLY_MAKE_DEPOSITS_THROUGH_THE_TRON_TRC20_NETWORK:
        'ONLY make deposits through the Tron (TRC20) network.',
      DO_NOT_USE_BEP2_BEP20_OMNI_TRC20_SOL:
        'BEP2, BEP20, OMNI, TRC20, SOL or other network standards as you may lose your funds.',
      DO_NOT_USE_BEP2_BEP20:
        'BEP2, BEP20, or other network standards as you may lose your deposit.',
      THE_USE_OF_CONTRACT_ADDRESSES_IS_NOT_ALLOWED:
        'The use of contract addresses is not allowed.',
      ONLY_SEND_ETHEREUM_METH: 'ONLY send Ethereum (mETH)',
      ONLY_WITHDRAW_ETHEREUM_METH: 'ONLY withdraw Ethereum (mETH)',
      ONLY_SEND_BITCOIN_MICRONBTC: 'ONLY send Bitcoin (µBTC)',
      ONLY_WITHDRAW_BITCOIN_MICRONBTC: 'ONLY withdraw Bitcoin (µBTC)',
      DO_NOT_USE_LIGHTNING_NETWORK:
        'Lightning Network, BEP20, BEP2, ERC20, Polygon or other network standards as you may lose your deposit.',
      ONLY_MAKE_DEPOSITS_THROUGH_THE_BTC_NETWORK:
        'ONLY make deposits through the BTC network.',
      SELECT_YOUR_CRYPTO_CURRENCY_DEPOSIT_METHOD:
        'Select your crypto currency deposit method',
      AMOUNT: 'Amount',
      ENTER_AMOUNT: 'Enter amount',
      ENTER_YOUR_CRYPTO_ADDRESS: 'Enter your crypto address',
      MIN_AMOUNT: 'Min Amount',
      MAX_AMOUNT: 'Max Amount',
      AMOUNT_REQUIRED: 'Amount is required',
      AMOUNT_TOO_LOW: 'Amount is too low',
      AMOUNT_TOO_HIGH: 'Amount is too high',
      RISKS_CONFIRMATION:
        "By clicking the 'Confirm' button, you indicate that you agree to the above-mentioned risks.",
      DEPOSIT: 'Deposit',
      WITHDRAWAL: 'Withdrawal',
      COPY_ADDRESS_OR_SCAN_QR_CODE: 'Copy the address or scan the QR Code',
      MINIMUM_DEPOSIT_AMOUNT: 'Minimum deposit amount {{amount}}',
      NOTE_ABOUT_THE_EXCHANGE_RATE:
        'Note about the exchange rate: Please note that the exchange rate at the completion of the transaction may differ slightly from the above.',
      TRANSACTION_COMPLETION:
        'Transaction completion: Please note that after completing a transaction, it may take up to 15 minutes for the change to be visible in your account balance.',
      VALIDATING_ADDRESS: 'Validating address',
      ADDRESS_VALID: 'Address is valid',
      INVALID_ADDRESS: 'Invalid address format',
      ADDRESS_VALIDATION_ERROR: 'Address validation failed',
      WITHDRAWAL_CANCELLED: 'Withdrawal has been successfully cancelled',
      CONFIRM_CANCEL_WITHDRAWAL:
        'Are you sure you want to cancel this withdrawal?',
    },
    // Provider display names + instructions. The DB column
    // `display_name_i18n_key` stores dotted keys like
    // `tnd.provider.telegate_ooredoo.name`; ngx-translate resolves them by
    // nested object lookup, so the structure below mirrors the dotted keys.
    tnd: {
      provider: {
        telegate_ooredoo: {
          name: 'Ooredoo',
          subtitle: 'Top up with an Ooredoo card',
          instructions:
            'Enter the codes printed on your Ooredoo scratch cards. Cards are credited individually within seconds.',
        },
        telegate_orange: {
          name: 'Orange',
          subtitle: 'Top up with an Orange card',
          instructions:
            'Enter the codes of your Orange scratch cards or e-tickets. Each card is credited automatically once Orange has confirmed its amount — usually within a few minutes.',
        },
        d17_deposit: {
          name: 'D17 Transfer',
          subtitle: 'From your D17 app',
          instructions:
            'Send the amount from your D17 app to the number we give you, then enter the transfer reference. Your deposit is verified and credited automatically.',
        },
        flouci_deposit: {
          name: 'Flouci Transfer',
          instructions:
            'Send the amount via Flouci, then upload the confirmation screenshot. Your deposit will be credited after manual verification.',
        },
        izi_card: {
          name: 'Bank card',
          subtitle: 'Visa / Mastercard',
          instructions:
            'Pay by bank card on a secure page. Your wallet is topped up instantly once the payment is confirmed.',
        },
        telegate_d17_card: {
          name: 'Bank card',
          subtitle: 'Visa / Mastercard',
          instructions:
            'Pay by bank card on a secure page. Your wallet is topped up instantly once the payment is confirmed.',
        },
        d17_withdrawal: {
          name: 'D17 Transfer',
          subtitle: 'To your D17 account',
          instructions:
            'Enter the recipient D17 number. The payout is sent instantly, no fee.',
        },
        flouci_withdrawal: {
          name: 'Flouci Transfer',
          instructions:
            'Enter the Flouci phone you want the funds sent to. We will transfer manually within the processing window below.',
        },
        mandat_minute: {
          name: 'Mandat Minute',
          subtitle: 'Cash withdrawal code at La Poste',
          instructions:
            'Enter the recipient name and phone. A claim code is issued instantly to collect the cash at any post office.',
        },
        cash_withdrawal: {
          name: 'Cash delivery',
          subtitle: 'Cash delivered to you in 6-12h',
          instructions:
            'Enter your details and our team will contact you on WhatsApp to arrange the cash delivery, within 6 to 12 hours.',
        },
      },
    },
    TND_PAYMENT: {
      // Picker
      DEPOSIT_TITLE: 'Deposit',
      WITHDRAWAL_TITLE: 'Withdrawal',
      CHOOSE_DEPOSIT_METHOD: 'Choose a deposit method',
      CHOOSE_WITHDRAWAL_METHOD: 'Choose a withdrawal method',
      SELF_ACCOUNT_REQUIRED:
        'Your account was not self-registered: it was opened at a betting shop and stays managed by that shop. Online deposits, withdrawals and transactions are reserved for self-registered accounts.',
      CRYPTO_CARD_LABEL: 'Cryptocurrency',
      AUTO_BADGE: 'Instant',
      INSTANT_BADGE: 'Instant',
      MANUAL_BADGE: 'Manual',
      RANGE_TND: '{{min}} - {{max}} TND',
      // -- IZI (Zitouna Pay) card deposit --
      IZI_INSTRUCTIONS: 'Pay by bank card. A secure payment page opens right here — enter your card details to top up instantly.',
      IZI_AMOUNT_LABEL: 'Amount to deposit',
      IZI_SECURE_HINT: 'Transaction secured by ClicToPay. The exact amount above is credited to your balance.',
      IZI_SUBMIT: 'Continue to payment',
      IZI_OPENING: 'Opening secure payment…',
      IZI_CHECKOUT_TITLE: 'Secure card payment',
      IZI_CHECKOUT_SUB: 'Enter your card details on the secure page below. This window closes automatically once your payment is confirmed.',
      IZI_SECURED_BY: 'Transaction secured by ClicToPay.',
      IZI_LOADING_CHECKOUT: 'Loading the secure payment page…',
      IZI_WAITING_PAYMENT: 'Waiting for your payment…',
      IZI_OPEN_NEW_TAB: 'Open in a new tab',
      IZI_RESULT_OK_TITLE: 'Payment confirmed',
      IZI_RESULT_FAIL_TITLE: 'Payment not completed',
      IZI_RESULT_FAIL_BODY: 'Your card payment did not go through. No amount was credited. You can try again.',
      IZI_RESULT_EXPIRED_TITLE: 'Payment session expired',
      IZI_RESULT_EXPIRED_BODY: 'The payment window expired before the payment was completed. No amount was credited. You can start a new deposit.',
      IZI_TIMEOUT_TITLE: 'Still processing',
      IZI_TIMEOUT_BODY: 'Your payment is taking longer than usual. If you completed the card payment, it will be credited shortly — check your transactions.',
      IZI_TRY_AGAIN: 'Try again',
      IZI_INIT_FAILED: 'We could not start the card payment. Please try again.',
      IZI_UNAVAILABLE: 'Card deposit is temporarily unavailable. Please try again later or use another method.',
      // D17 card top-up (MasterCard / La Poste through TeleGate)
      D17CARD_INSTRUCTIONS: 'Secure Visa or Mastercard payment, credited instantly. Whole amounts only.',
      D17CARD_AMOUNT_LABEL: 'Amount to deposit',
      D17CARD_FEE_HINT: 'Bank fee: 0.250 TND + 0.8 %. Your card will be charged about {{charged}} TND.',
      D17CARD_FEE_HINT_GENERIC: 'Bank fee: 0.250 TND + 0.8 % of the amount.',
      D17CARD_SUBMIT: 'Continue to payment',
      D17CARD_OPENING: 'Preparing payment…',
      D17CARD_PREPARING_TITLE: 'Preparing your payment',
      D17CARD_PREPARING_BODY: 'A few more moments, your payment page is on its way. Keep this window open.',
      D17CARD_PREPARING_SLOW: 'Thank you for your patience, this is taking a little longer than expected. Your page is on its way.',
      D17CARD_STEP_SENT: 'Request received',
      D17CARD_STEP_BANK: 'Preparing your secure payment space',
      D17CARD_STEP_FORM: 'Card payment',
      D17CARD_CHECKOUT_TITLE: 'Card payment',
      D17CARD_CHARGED_LINE: '{{credited}} TND credited · {{charged}} TND charged, bank fee included.',
      D17CARD_SECURED_BY: 'Secured by Mastercard',
      D17CARD_LOADING_CHECKOUT: 'Loading the payment page…',
      D17CARD_WAITING_PAYMENT: 'Waiting for payment',
      D17CARD_VALID_UNTIL: 'valid until {{time}}',
      D17CARD_PAGE_VALID_UNTIL: 'Payment page valid until {{time}}.',
      D17CARD_CANCEL_PAYMENT: 'Cancel this payment',
      D17CARD_CANCELLING: 'Cancelling…',
      D17CARD_FRAMED_BODY: 'The payment page must open in its own window.',
      D17CARD_OPEN_WINDOW: 'Open the payment page',
      D17CARD_WINDOW_OPENED: 'Complete the payment in the new window. This page updates automatically.',
      D17CARD_VERIFYING_TITLE: 'Payment being verified',
      D17CARD_VERIFYING_BODY: 'A payment is being verified: this deposit can no longer be cancelled. It will be credited or closed within a few minutes.',
      D17CARD_DO_NOT_CLOSE: 'Finalising, please do not close this window.',
      D17CARD_CLOSE_GUARDED: 'A card payment is in progress. To leave, use “Cancel payment”.',
      D17CARD_RESULT_OK_TITLE: 'Payment confirmed',
      D17CARD_RESULT_FAIL_TITLE: 'Payment not completed',
      D17CARD_RESULT_FAIL_BODY: 'The payment did not go through. No amount was credited.',
      D17CARD_RESULT_EXPIRED_TITLE: 'Payment page expired',
      D17CARD_RESULT_EXPIRED_BODY: 'The page expired without a payment. No amount was credited.',
      D17CARD_RESULT_CANCELLED_TITLE: 'Payment cancelled',
      D17CARD_RESULT_CANCELLED_BODY: 'No amount was credited. If your card was charged anyway, it is credited automatically once confirmed.',
      D17CARD_RESULT_CLOSED_BODY: 'Closed after verification: no payment was found. If your card was charged, contact support with your reference.',
      D17CARD_REVIEW_TITLE: 'Payment being verified',
      D17CARD_REVIEW_BODY: 'We are checking this payment. If your card was charged, the amount will be credited. No action is needed.',
      D17CARD_TIMEOUT_TITLE: 'Still pending',
      D17CARD_TIMEOUT_BODY: 'No payment received yet. Follow this deposit in your transactions.',
      D17CARD_TIMEOUT_RESUME_BODY: 'No payment received yet. You can resume the payment on the same page.',
      D17CARD_RESUME_PAYMENT: 'Resume payment',
      D17CARD_PENDING_RESUME_BODY: 'Your card payment of {{amount}} TND is pending. Resume it to finish, or cancel it.',
      D17CARD_TRY_AGAIN: 'Try again',
      D17CARD_INIT_FAILED: 'We could not start the card payment. Please try again.',
      D17CARD_UNAVAILABLE: 'Card deposit is temporarily unavailable. Please try again later or use another method.',
      D17CARD_UNAVAILABLE_UNTIL: 'Card deposit is temporarily unavailable. Please try again at {{time}} or use another method.',
      D17CARD_BUSY: 'Card payment is temporarily unavailable. Please try again in a few minutes or use another method.',
      D17CARD_BUSY_UNTIL: 'Card payment is temporarily unavailable. Please try again at {{time}} or use another method.',
      D17CARD_PROCESSING_OVERLAY_TITLE: 'Processing your payment',
      D17CARD_PROCESSING_OVERLAY_BODY: 'A few seconds. Do not close this window.',
      D17CARD_ACCEPTED_OVERLAY_TITLE: 'Payment accepted by your bank',
      D17CARD_ACCEPTED_OVERLAY_BODY: 'Confirming it, a few seconds. Do not close this window.',
      D17CARD_UNVERIFIED_OVERLAY_TITLE: 'Payment being verified',
      D17CARD_UNVERIFIED_OVERLAY_BODY: 'If your card was charged, the amount is credited automatically. If not, nothing is taken from you.',
      D17CARD_UNVERIFIED_FOOTER: 'This deposit stays tracked: you can close this window.',
      D17CARD_DAILY_LIMIT: 'Daily limit of card payments reached. Please try again tomorrow or use another method.',
      D17CARD_TOO_SOON: 'Please wait a moment before another card payment.',
      D17CARD_TOO_SOON_AT: 'Please wait before another card payment: try again at {{time}}.',
      D17CARD_WHOLE_TND: 'Whole amounts only (20, not 20.5).',
      D17CARD_GATEWAY_ERROR: 'The payment page reported a problem. If you paid, do not pay again: the amount will be credited once confirmed.',
      D17CARD_NO_INDICATOR: 'Payment accepted, but the receipt could not be read. Do not pay again; if the amount is not credited within a few minutes, contact support with your reference.',
      // -- Auto D17 claim deposit --
      D17_CLAIM_INSTRUCTIONS: 'Send money from your D17 app to the number below, then enter the transfer details.',
      D17_SEND_TO: 'Send your D17 transfer to this number',
      D17_TARGET_ROTATES_LEAD: 'This number changes regularly.',
      D17_TARGET_ROTATES_BODY: "Check it here before every transfer — an old number won't be credited.",
      D17_TARGET_LOADING: 'Getting a deposit number…',
      D17_CANT_RECEIVE: 'Change number',
      D17_TARGETS_EXHAUSTED: "You've been shown every available number — starting again from the first.",
      D17_AMOUNT_LABEL: 'Amount sent (TND)',
      D17_SENDER_PHONE_LABEL: 'Your D17 number',
      D17_SENDER_PHONE_PLACEHOLDER: 'The number you sent from',
      D17_SENDER_PHONE_REQUIRED: 'Your D17 number is required.',
      D17_AUTORISATION_LABEL: 'Transfer reference',
      D17_AUTORISATION_PLACEHOLDER: 'e.g. 977061',
      D17_AUTORISATION_HINT: 'The authorization/reference number shown in your D17 app after the transfer.',
      D17_AUTORISATION_REQUIRED: 'The transfer reference is required.',
      D17_AUTORISATION_INVALID: 'The reference must be exactly 6 digits.',
      AMOUNT_DIGITS_ONLY: 'Enter a whole number (digits only).',
      D17_ADJUSTED_UNDER: 'We credited the exact amount that arrived, which was less than you entered.',
      D17_ADJUSTED_OVER: 'We credited the exact amount that arrived, which was more than you entered.',
      D17_RESULT_THROTTLED_BODY: 'Too many failed attempts. Please wait a few minutes before trying again.',
      // -- one-pending-deposit gate --
      PENDING_GATE_TITLE: 'You have a pending deposit',
      PENDING_GATE_BODY: 'Finish or cancel your current {{method}} deposit before starting a new one.',
      PENDING_GATE_CANCEL: 'Cancel pending deposit',
      PENDING_GATE_CANCELLING: 'Cancelling…',
      PENDING_GATE_VIEW: 'View it in my transactions',
      // -- 3-strikes deposit failure lockout --
      LOCKED_TITLE: 'Deposits temporarily paused',
      LOCKED_BODY: 'Your last {{threshold}} deposit attempts failed, so deposits are paused for a short while. Your money is safe — nothing was taken from your wallet.',
      LOCKED_RESUME_AT: 'You can deposit again at {{time}}',
      LOCKED_NOTICE: 'Deposits are paused for 1 hour. You can deposit again at {{time}}.',
      ATTEMPT_X_OF_N: 'Failed attempt {{streak}} of {{threshold}}.',
      ATTEMPTS_REMAINING: '{{remaining}} attempt(s) remaining before deposits are paused for 1 hour.',
      LAST_ATTEMPT_WARNING: 'Careful — one more failed deposit and deposits will be paused for 1 hour. Double-check your details before submitting.',
      REJECTED_STRIKE_NOTE: 'Heads up: repeated failed or rejected deposits temporarily pause new deposits for 1 hour.',
      CONTACT_SUPPORT: 'Contact support',
      DEPOSIT_FAILED_NOTHING_TAKEN: 'Nothing was taken from your wallet for this deposit.',
      D17_SUBMIT: 'Verify my transfer',
      D17_PROCESSING_TITLE: 'Verifying your transfer…',
      D17_PROCESSING_BODY: 'We are checking your D17 transfer against the account journal. This takes a few seconds.',
      D17_RESULT_OK_TITLE: 'Deposit credited',
      D17_RESULT_REVIEW_TITLE: 'Under review',
      D17_RESULT_REVIEW_BODY: 'We received your transfer details but need a quick manual check (the sender did not match). Your deposit will be credited once verified.',
      D17_RESULT_FAIL_TITLE: 'Transfer not verified',
      D17_RESULT_FAIL_BODY: 'We could not verify this transfer. Please double-check the reference and sender number, or contact support.',
      D17_UNAVAILABLE: 'D17 deposits are temporarily unavailable. Please try again later or use another method.',
      // -- Auto (instant) withdrawal --
      AUTO_D17_INSTRUCTIONS: 'Enter the recipient D17 number. The payout is sent instantly.',
      AUTO_MANDAT_INSTRUCTIONS: 'Enter the recipient details. A cash-pickup claim code is issued instantly for collection at any post office.',
      WITHDRAWABLE_BALANCE: 'Withdrawable balance',
      WITHDRAWAL_AMOUNT_LABEL: 'Amount to withdraw (TND)',
      WITHDRAWAL_FEE_NET: 'Fee {{fee}} TND — recipient collects {{net}} TND',
      RECIPIENT_NAME_LABEL: 'Recipient full name',
      RECIPIENT_NAME_PLACEHOLDER: 'As on their ID (for post-office pickup)',
      RECIPIENT_NAME_REQUIRED: 'The recipient full name is required.',
      AUTO_D17_NOT_REGISTERED_TITLE: "This number isn't on D17",
      AUTO_D17_NOT_REGISTERED_BODY: "The recipient number isn't registered with D17, so the transfer couldn't go through — nothing was sent. Double-check the number and try again, or send the money as a Mandat Minute cash pickup instead.",
      USE_MANDAT_INSTEAD: 'Send as Mandat Minute instead',
      MANDAT_SWITCH_HINT: 'Cash pickup at the post office — the recipient collects {{net}} TND ({{fee}} TND fee).',
      RECIPIENT_PHONE_PLACEHOLDER: '8-digit Tunisian number',
      RECIPIENT_PHONE_REQUIRED: 'The recipient phone is required.',
      AUTO_WITHDRAWAL_SUBMIT: 'Withdraw now',
      AUTO_WITHDRAWAL_PROCESSING_TITLE: 'Processing your withdrawal…',
      AUTO_WITHDRAWAL_PROCESSING_BODY: 'Your payout is being sent. This usually completes in a few seconds.',
      AUTO_WITHDRAWAL_OK_TITLE: 'Withdrawal completed',
      AUTO_D17_PAID: 'Sent to the recipient',
      D17_AUTH_CODE: 'Authorization number',
      D17_AUTH_CODE_HINT: 'Transfer authorization — the recipient sees this number in their D17 app.',
      MANDAT_CLAIM_HINT: 'Give this claim code to the recipient — they collect the cash at any post office.',
      MANDAT_CLAIM_CODE: 'Claim code',
      MANDAT_NET: 'Amount to collect',
      MANDAT_VALID_UNTIL: 'Collect before',
      WD_STAGE_BALANCE: 'Checking your balance',
      WD_STAGE_MANDAT_EMIT: 'Issuing the money order at La Poste',
      WD_STAGE_MANDAT_CODE: 'Generating the code',
      WD_STAGE_D17_SEND: 'Sending to the D17 account',
      WD_STAGE_D17_CONFIRM: 'Confirming the transfer',
      WD_DO_NOT_CLOSE: 'Please keep this window open.',
      WD_SLOW_RAIL: 'The network is a little slower than usual — your withdrawal is safely registered, please stay on this page.',
      MANDAT_ISSUED_TITLE: 'Money order issued',
      MANDAT_WHO_CIN: 'ID card (CIN) required',
      MANDAT_IMPORTANT_LINK: 'Important — please read',
      MANDAT_IMPORTANT_HIDE: 'Important — hide',
      MANDAT_IMPORTANT_BODY: 'Only {{name}} can collect this money order. The counter checks their national ID card (CIN) against the exact name shown: without a valid CIN the pickup cannot be completed.',
      COPY_CODE: 'Copy the code',
      CODE_COPIED: 'Code copied ✓',
      D17_SENT_TO_HEADER: 'Sent to the D17 account',
      RECIPIENT_NUMBER: 'Recipient number',
      AMOUNT_RECEIVED_ROW: 'Amount received',
      STATUS_ROW: 'Status',
      STATUS_CREDITED: 'Credited',
      MANDAT_CARD_TITLE: 'Post-office cash pickup',
      MANDAT_ID_HINT: 'The recipient presents this code with their ID card at any post office.',
      COPY: 'Copy',
      COPIED: 'Copied!',
      AUTO_WITHDRAWAL_FAIL_TITLE: 'Withdrawal failed',
      AUTO_WITHDRAWAL_FAIL_BODY: 'The payout could not be completed.',
      AUTO_WITHDRAWAL_REFUNDED: 'The amount was returned to your wallet.',
      AUTO_WITHDRAWAL_REVIEW_TITLE: 'Withdrawal under review',
      AUTO_WITHDRAWAL_REVIEW_BODY: 'Your withdrawal is being verified by our team. You will be notified once it is processed.',
      AUTO_WITHDRAWAL_REVIEW_RESERVED: 'This amount is reserved in your wallet until the review completes (or you cancel).',
      AUTO_WITHDRAWAL_TRY_AGAIN: 'Try again',
      AUTO_WITHDRAWAL_TIMEOUT_TITLE: 'Still processing',
      AUTO_WITHDRAWAL_TIMEOUT_BODY: 'Your withdrawal is taking longer than usual. Check your transactions for the final status.',
      WITHDRAWAL_DAILY_CAP: 'You have reached your daily withdrawal limit. Please try again tomorrow.',
      WITHDRAWAL_PENDING_EXISTS: 'You already have a withdrawal being processed — please wait for it to finish before requesting another.',
      WITHDRAWAL_TOO_SOON: 'Please wait a minute before requesting another withdrawal.',
      WITHDRAWAL_INSUFFICIENT: 'Insufficient withdrawable balance for this amount.',
      STATUS_PROCESSING: 'Processing',
      STATUS_AWAITING_REVIEW: 'Under review',
      RETRY: 'Retry',
      LOADING_METHODS: 'Loading payment methods…',
      NO_METHODS: 'No payment methods available right now.',
      COMING_SOON_TAG: 'Coming soon',
      COMING_SOON_AUTO_BODY: 'Instant deposits via this provider are launching very soon. In the meantime, please pick another deposit method below.',
      PICK_ANOTHER_METHOD: 'Pick another method',

      // Telegate scratch-card deposit (Phase 1c)
      TND: 'TND',
      SCRATCH_HELP_TITLE: 'How it works',
      SCRATCH_HELP_STEP1: 'Scratch the silver panel on your Ooredoo card to reveal the recharge code.',
      SCRATCH_HELP_STEP2: 'Tap “Scan cards” to read it with your camera, or type the 14-digit code by hand.',
      SCRATCH_HELP_STEP3: 'Enter the total amount and submit — your balance is credited automatically.',
      SCRATCH_HELP_CODE_HINT: 'Use the 14-digit code in the box (e.g. 0743 0951 1566 39) — not the serial number printed under the barcode.',
      SCRATCH_HELP_IMG_ALT: 'Example of Ooredoo recharge cards',
      SCRATCH_INSTRUCTIONS: 'Top up with Ooredoo recharge cards — credited automatically after verification.',
      // Orange variants (resolved as <KEY>_ORANGE, falling back to <KEY>).
      // Orange is codes-only: the operator measures each card's amount.
      SCRATCH_INSTRUCTIONS_ORANGE: 'Top up with Orange recharge cards — credited automatically once Orange has confirmed each card’s amount.',
      SCRATCH_HELP_STEP1_ORANGE: 'Scratch the panel on your Orange card — or open your Orange e-ticket — to reveal the 14-digit recharge code.',
      SCRATCH_HELP_STEP2_ORANGE: 'Enter each 14-digit code, one card per line.',
      SCRATCH_HELP_STEP3_ORANGE: 'Enter the total of your cards and submit — Orange measures each card’s amount and your balance is credited automatically.',
      SCRATCH_HELP_CODE_HINT_ORANGE: 'Physical card: the code is printed in 4 groups (e.g. 9264 3246 9666 42) — not the serial number or the barcode digits. E-ticket: the code is the 14 digits printed together — not the 12-digit serial number printed under it.',
      SCAN_HINT_ORANGE: 'Use the camera or pick a photo — clear and well-lit. Only the codes are read: enter the total yourself, Orange measures each card’s amount.',
      SCRATCH_PROCESSING_BODY_ORANGE: 'Orange is validating your cards. Allow a few seconds to a few minutes — stay here, your balance updates by itself.',
      SCRATCH_TIMEOUT_BODY_ORANGE: 'Your cards are still being validated — nothing is lost. Find them in Wallet; your balance is credited automatically once confirmed.',
      SCRATCH_AMOUNT_LABEL: 'Total amount (TND)',
      // Providers whose amount is NOT asked (amount_mode 'auto' — Orange: the
      // cards print no value). {{operator}} is the provider's display name.
      SCRATCH_AMOUNT_AUTO_NOTE: 'The amount is detected automatically by {{operator}} once each card is validated.',
      SCRATCH_HELP_STEP3_AUTO: 'Submit — there is no amount to enter: {{operator}} measures each card’s amount and your balance is credited automatically.',
      SCAN_HINT_AUTO: 'Use the camera or pick a photo — clear and well-lit. Only the codes are read: {{operator}} detects each card’s amount.',
      SCRATCH_CODES_LABEL: 'Scratch card codes',
      SCRATCH_CODES_HINT: 'Add up to 10 cards. Each code is the number hidden under the scratch panel.',
      SCRATCH_CODE_PLACEHOLDER: 'Card code',
      SCRATCH_CODE_REQUIRED: 'Enter the scratch card code.',
      SCRATCH_CODE_INVALID: 'Code must be 14 digits.',
      SCRATCH_CODE_DUPLICATE: 'This code is already entered. Each scratch card can only be used once.',
      SCRATCH_ADD_CODE: 'Add another card',
      SCRATCH_REMOVE_CODE: 'Remove this card',
      SCRATCH_CARD: 'Card',
      SCRATCH_SUBMIT: 'Recharge now',
      SCRATCH_PROCESSING_TITLE: 'Your top-up is on its way',
      SCRATCH_PROCESSING_BODY: 'This usually takes a few seconds. Please keep this window open.',
      SCRATCH_STATUS_PENDING: 'Pending',
      SCRATCH_STATUS_PROCESSING: 'Processing',
      SCRATCH_STATUS_COMPLETED: 'Done',
      SCRATCH_STATUS_FAILED: 'Refused',
      // A held card is being verified — never "rejected", whatever its code.
      SCRATCH_STATUS_NEEDS_REVIEW: 'Being verified',
      // Telegate's per-card phase while a card is in flight (Orange/TT queue).
      SCRATCH_PHASE_QUEUED: 'Waiting',
      SCRATCH_PHASE_CHECKING: 'Checking…',
      SCRATCH_PHASE_MEASURING: 'Accepted ✓ · amount coming',
      SCRATCH_QUEUE_LINE: 'Your turn is coming · about {{eta}} s',
      SCRATCH_QUEUE_LINE_MIN: 'Your turn is coming · about {{minutes}} min',
      SCRATCH_QUEUE_AHEAD_ONE: '1 card ahead of yours',
      SCRATCH_QUEUE_AHEAD: '{{ahead}} cards ahead of yours',
      SCRATCH_NO_LANE_LINE: 'One moment — your cards are safely registered and nothing has been used.',
      SCRATCH_HOLD_AUTO_BODY: 'Card accepted! Orange is confirming the amount — 1 to 3 more minutes, we’re on it.',
      SCRATCH_REJECTED_NOTICE: 'Some cards were not accepted:',
      SCRATCH_REJECTED_REASON_COMPLETED: 'Already used',
      SCRATCH_REJECTED_REASON_IN_PROGRESS: 'Being processed — retry later',
      SCRATCH_REJECTED_REASON_UNDER_REVIEW: 'Under verification',
      SCRATCH_REJECTED_REASON_FAILED: 'Temporarily blocked — retry later',
      SCRATCH_REJECTED_REASON_DUPLICATE_IN_REQUEST: 'Entered twice',
      SCRATCH_REJECTED_REASON_NO_ELIGIBLE_SIMS: 'No line free — not used, retry later',
      SCRATCH_RESULT_OK_TITLE: 'Deposit credited 🎉',
      SCRATCH_RESULT_FAIL_TITLE: 'Deposit failed',
      SCRATCH_RESULT_FAIL_BODY: 'None of your cards could be validated. Check the codes and try again.',
      // A failure that never counted as a strike (lock-exempt): no "check your
      // codes", no "same codes" promise — a manual check may have found a card used.
      SCRATCH_RESULT_FAIL_NO_STRIKE_BODY: 'This deposit could not be completed. Nothing counts against you — it is not a failed attempt.',
      SCRATCH_RESULT_REVIEW_TITLE: 'Cards under review',
      SCRATCH_RESULT_REVIEW_BODY: 'Your cards are being verified. Nothing is lost: the credit lands automatically once confirmed, sometimes a little later. You can deposit another way meanwhile.',
      SCRATCH_RESULT_REVIEW_AUTO_BODY: 'Almost there! Your cards are accepted and the amount is being confirmed. Your balance will be credited automatically within minutes — follow it in Wallet.',
      SCRATCH_RESULT_NO_LINE_TITLE: 'Service temporarily unavailable',
      SCRATCH_RESULT_NO_LINE_BODY: 'Your cards were not used — try again in a few minutes with the same codes. This does not count as a failed attempt.',
      SCRATCH_RESULT_RETRY_TITLE: 'Retrying automatically',
      SCRATCH_RESULT_RETRY_BODY: 'Retrying now — nothing to do on your side, and it does not count as a failed attempt.',
      SCRATCH_RESULT_INFRA_TITLE: 'Service temporarily unavailable',
      SCRATCH_RESULT_INFRA_BODY: 'Your cards were not used — try again in a few minutes with the same codes. This does not count as a failed attempt.',
      SCRATCH_ERROR_NOT_USED: 'Not used — try again in a few minutes',
      DEPOSIT_AUTO_RETRY_BODY: 'A card was not consumed by the operator: it was re-submitted automatically as a new deposit.',
      DEPOSIT_AUTO_RETRY_CHILD_BODY: 'This deposit is the automatic re-submission of a card the operator had not consumed.',
      SCRATCH_CREDITED: 'Credited to your wallet:',
      SCRATCH_MISMATCH: 'You entered {{declared}} TND but {{detected}} TND was detected on your cards. Your wallet was credited based on the detected amount.',
      SCRATCH_MISMATCH_OVER_CREDITED: 'You entered {{declared}} TND but {{detected}} TND was detected on your cards. Your wallet was credited on the full detected amount.',
      SCRATCH_MISMATCH_CAPPED: 'You entered {{declared}} TND but {{detected}} TND was detected on your cards. Your wallet was credited {{declared}} TND — our team automatically double-checks the difference.',
      // Fees (per-method, configured on the provider row)
      FEE_LABEL: 'Fee',
      FEE_PERCENT_NOTE: '{{percent}}% fee deducted',
      FEE_PERCENT_ESTIMATE: 'Fee {{percent}}% — you will receive about {{net}} TND.',
      FEE_DETECTED_GROSS: 'Cards detected',
      FEE_NET_CREDITED: 'Credited to balance',
      FEE_NET_RECEIVED: 'You receive',
      WITHDRAWAL_NET_HINT: 'You will receive {{net}} TND (fee: {{fee}} TND).',
      SCRATCH_NEW_DEPOSIT: 'New deposit',
      SCRATCH_TIMEOUT_TITLE: 'Still processing',
      SCRATCH_TIMEOUT_BODY: 'This is taking longer than usual. You can track the result in your Wallet tab.',
      SCRATCH_CARD_DETAILS: 'Scratch cards',
      SCRATCH_SUMMARY_LABEL: 'Summary',
      SCRATCH_SUMMARY: '{{completed}} of {{total}} card(s) credited · {{amount}} TND total',
      SCRATCH_ERROR_INVALID_CODE: 'Invalid code',
      SCRATCH_ERROR_ALREADY_USED: 'Already used',
      SCRATCH_ERROR_GENERIC: 'Could not be processed',
      SCRATCH_ERROR_CARD_REFUSED: 'Refused by the operator',
      SCRATCH_ERROR_NO_LINE: 'Not used — try again in a few minutes',
      SCRATCH_ERROR_ALL_SIMS_FAILED: 'The operator could not process this card — try again later',
      SCRATCH_ERROR_AMOUNT_UNVERIFIED: 'Amount not confirmed by the operator — contact support',
      SCAN_CARDS: 'Scan my cards',
      SCAN_SUBLABEL: 'The codes fill in automatically',
      SCAN_TAKE_PHOTO: 'Take a photo',
      SCAN_FROM_GALLERY: 'From the gallery',
      TYPE_MANUALLY: 'Enter codes manually',
      SCANNING: 'Reading…',
      SCAN_HINT: 'Use the camera or pick a photo — clear and well-lit; several cards at once is fine.',
      SCAN_DETECTED: '{{count}} code(s) detected — please verify each one.',
      SCAN_NO_CODES: 'No code found. Make sure the code is visible and well-lit, then retake — or type it below.',
      SCAN_FAILED: 'Scan failed. Please try again, or enter the codes manually.',
      SCAN_CAP_REACHED: 'You have reached today\u2019s scan limit. Please enter the codes manually.',
      SCAN_IMAGE_TOO_LARGE: 'That image is too large. Please retake and try again.',
      SCAN_CAMERA_HELP: 'Camera not working? Allow camera access for your browser in your phone settings (e.g. Settings → Safari or Chrome → Camera), or pick an existing photo from your gallery.',
      TOO_MANY_CARDS_BLOCK: '{{count}} cards detected — the maximum per deposit is {{max}}. Please remove {{over}}.',
      SCAN_LOW_CONFIDENCE: 'Low scan quality — please double-check this code.',
      SCAN_VERIFY_CODE: 'Read from your photo — please check it against your card.',
      SCRATCH_AMOUNT_AUTO: 'Total detected from your cards — please double-check it.',
      SCRATCH_AMOUNT_UNREADABLE: 'We couldn\'t read the amount on one of the cards — scan it again closer, or enter the total yourself.',

      // Provider display names (resolved from display_name_i18n_key in the backend seed)
      // Manual deposit form
      AMOUNT_LABEL: 'Amount (TND)',
      AMOUNT_PLACEHOLDER: 'e.g. 50',
      AMOUNT_HINT_RANGE: 'Between {{min}} and {{max}} TND',
      AMOUNT_REQUIRED: 'Amount is required.',
      AMOUNT_TOO_LOW: 'Minimum is {{min}} TND.',
      AMOUNT_TOO_HIGH: 'Maximum is {{max}} TND.',
      AMOUNT_NOT_NUMERIC: 'Enter a valid number.',
      AMOUNT_NOT_MULTIPLE: 'Amount must be a multiple of {{multiple}} TND (e.g. 150, 160, 170…).',
      D17_PHONE_LABEL: 'Your D17 phone number',
      D17_PHONE_PLACEHOLDER: 'e.g. 99999999',
      D17_AUTH_LABEL: 'Authorisation code (optional)',
      D17_AUTH_PLACEHOLDER: 'D17 authorisation code if displayed',
      D17_AUTH_HELP_LINK: 'Where do I find it?',
      D17_AUTH_HELP_CAPTION: 'After sending the money in the D17 app, the confirmation screen shows your authorisation number (highlighted in red above).',
      D17_AUTH_HELP_IMG_ALT: 'D17 confirmation screen with the authorisation number highlighted',
      SECTION_PAYMENT_DETAILS: 'Your payment',
      SECTION_PAYMENT_PROOF: 'Proof of payment',
      FLOUCI_PHONE_LABEL: 'Your Flouci phone number',
      FLOUCI_NAME_LABEL: 'Your Flouci account name',
      FLOUCI_NAME_PLACEHOLDER: 'Full name registered on Flouci',
      FLOUCI_REFERENCE_LABEL: 'Transaction reference',
      FLOUCI_REFERENCE_PLACEHOLDER: 'Reference shown by Flouci after sending',
      PHONE_INVALID: 'Enter a valid Tunisian phone number.',
      NAME_INVALID: 'Enter a valid name (letters only, no numbers).',

      // Capture upload
      CAPTURE_LABEL: 'Confirmation screenshot',
      CAPTURE_HINT: 'Upload a clear photo of the transfer confirmation. JPG, PNG, HEIC or PDF, up to 4 MB.',
      CAPTURE_PICK: 'Take photo or choose file',
      CAPTURE_RETAKE: 'Replace',
      CAPTURE_REQUIRED: 'A confirmation screenshot is required.',
      CAPTURE_TYPE_NOT_ALLOWED: 'This file type is not allowed. Use JPG, PNG, HEIC or PDF.',
      CAPTURE_TOO_LARGE: 'File too large. Maximum 4 MB.',
      CAPTURE_UPLOADING: 'Uploading… {{percent}}%',
      CAPTURE_UPLOADED: 'Uploaded',
      CAPTURE_FAILED: 'Upload failed. Please try again.',

      // Withdrawal form
      RECIPIENT_PHONE_LABEL: 'Recipient phone',
      RECIPIENT_PHONE_HINT: 'The phone that will receive the money.',
      RECIPIENT_FULL_NAME_LABEL: 'Recipient full name',
      RECIPIENT_FULL_NAME_HINT: 'The name registered with Mandat Minute.',
      MIN_PROCESSING_TIME: 'Processing time: {{min}}-{{max}} minutes',
      MIN_PROCESSING_TIME_OPEN: 'Processing time: about {{min}} minutes',
      // -- Cash delivery withdrawal --
      CASH_NAME_HINT: 'The person receiving the cash (as on their ID).',
      CASH_CONTACT_PHONE_LABEL: 'Your WhatsApp number',
      CASH_CONTACT_PHONE_HINT: 'Our team contacts you on this number to arrange the delivery.',
      CASH_REGION_LABEL: 'Region',
      CASH_REGION_PLACEHOLDER: 'Choose your region',
      CASH_DELIVERY_WINDOW: 'Cash is delivered within 6 to 12 hours.',
      WITHDRAWAL_REQUIRED_BALANCE_NOTE:
        'Withdrawals are paid from your withdrawable balance. Place bets to grow it from your deposit balance.',

      // Submit + success
      SUBMIT_DEPOSIT: 'Submit deposit',
      SUBMIT_WITHDRAWAL: 'Submit withdrawal',
      SUBMITTING: 'Submitting…',
      PHASE_CREATING: 'Creating your deposit…',
      PHASE_UPLOADING: 'Uploading your proof…',
      PHASE_CONFIRMING: 'Finalising…',
      DEPOSIT_SUBMITTED_TITLE: 'Deposit submitted',
      DEPOSIT_SUBMITTED_BODY: 'We will credit your wallet after verifying your transfer. You can track this in your Wallet tab.',
      WITHDRAWAL_SUBMITTED_TITLE: 'Withdrawal submitted',
      WITHDRAWAL_SUBMITTED_BODY: 'Your withdrawable balance has been held. We will release the transfer once it is approved.',
      VIEW_TRANSACTIONS: 'View my transactions',
      MAKE_ANOTHER: 'Make another',

      // Wallet transactions tab
      WALLET_TAB_TITLE: 'Wallet Transactions',
      DIRECTION: 'Direction',
      ALL: 'All',
      DEPOSIT_FILTER: 'Deposits',
      WITHDRAWAL_FILTER: 'Withdrawals',
      STATUS: 'Status',
      METHOD: 'Method',
      AMOUNT: 'Amount',
      DATE: 'Date',
      EMPTY_TRANSACTIONS: 'No transactions yet.',
      VIEW_DETAIL: 'View',
      STATUS_PENDING: 'Pending',
      STATUS_COMPLETED: 'Completed',
      STATUS_REJECTED: 'Rejected',
      STATUS_CANCELLED: 'Cancelled',
      STATUS_FAILED: 'Failed',
      STATUS_EXPIRED: 'Expired',

      // Transaction detail modal
      DETAIL_TITLE: 'Transaction details',
      REQUEST_CODE: 'Reference',
      AMOUNT_REQUESTED: 'Amount requested',
      AMOUNT_CREDITED: 'Amount credited',
      AMOUNT_DECLARED: 'Amount entered',
      // Orange deposit (amount not asked) not credited yet: no figure to show.
      AMOUNT_AUTO_PENDING: 'Being validated',
      BALANCE_BEFORE: 'Balance before',
      BALANCE_AFTER: 'Balance after',
      WITHDRAWABLE_BEFORE: 'Withdrawable before',
      WITHDRAWABLE_AFTER: 'Withdrawable after',
      SUBMITTED_AT: 'Submitted',
      COMPLETED_AT: 'Completed',
      REJECTED_AT: 'Rejected',
      CANCELLED_AT: 'Cancelled',
      REJECT_REASON: 'Reject reason',
      WITHDRAWAL_REFERENCE: 'Reference (your money was sent with this code)',
      WITHDRAWAL_SENDER_PHONE: 'Sent from',
      USER_DATA_TITLE: 'You submitted',
      CANCEL_WITHDRAWAL: 'Cancel withdrawal',
      CANCEL_DEPOSIT: 'Cancel deposit',
      CONFIRM_CANCEL_DEPOSIT: 'Cancel this pending deposit? If the payment already went through, it will be credited instead.',
      DEPOSIT_ALREADY_LANDED: 'Your payment had already arrived — it was credited to your wallet.',
      CONFIRM_CANCEL: 'Are you sure you want to cancel this withdrawal? Your held balance will be refunded.',
      CONFIRM_CANCEL_YES: 'Yes, cancel it',
      CONFIRM_CANCEL_NO: 'Keep it',
      CANCELLATION_SUCCESS: 'Withdrawal cancelled. Your balance has been refunded.',
      DEPOSIT_CANCELLATION_SUCCESS: 'Deposit cancelled.',
      DEPOSIT_NOW_UNDER_REVIEW: 'This deposit could not be cancelled: a real payment was found and is being verified. It will be credited automatically once confirmed.',
      DEPOSIT_STATUS_UPDATED: 'This deposit has been updated — check its new status in the list.',
      CANCEL_NOT_POSSIBLE_YET: 'Your cards are being processed and the deposit will settle in a few seconds — it can no longer be cancelled.',
      CANCEL_NOT_POSSIBLE_YET_ORANGE: 'Your cards are waiting their turn on an Orange line and will be processed in the next few minutes (up to an hour at busy times) — this deposit can no longer be cancelled. Follow it in your Wallet tab.',
      CANCEL_NOT_POSSIBLE_YET_TT: 'Your cards are waiting their turn on a Tunisie Telecom line and will be processed in the next few minutes (up to an hour at busy times) — this deposit can no longer be cancelled. Follow it in your Wallet tab.',
      CANCEL_NOT_POSSIBLE_GENERIC: 'This deposit is still being resolved with the payment provider and cannot be cancelled right now. Please try again shortly.',
      CANCEL_NOT_POSSIBLE_CARD: 'A card payment is being verified on this deposit — it can no longer be cancelled. It will be credited or closed within minutes.',
      DEPOSIT_PROCESSING_HINT: 'This deposit is being processed with the payment provider.',
      DEPOSIT_REVIEW_BODY: 'This deposit is being verified by the payment provider. It will be credited automatically once confirmed (this can take a few days).',
      DEPOSIT_REVIEW_AUTO_BODY: 'Your cards were accepted and the operator is confirming the amount. This usually takes a few minutes — the deposit is credited automatically.',
      CLOSE: 'Close',

      // Errors
      GENERIC_ERROR: 'Something went wrong. Please try again.',
      ERR_CARD_ALREADY_USED: 'This recharge card has already been used. Check the code or try another card.',
      ERR_CARD_INVALID: 'This card code is not valid. Check the digits under the scratch panel.',
      ERR_CARD_IN_PROGRESS: 'This card is already being processed. Wait a few minutes and try again — no need to change cards.',
      ERR_CARD_UNDER_REVIEW: 'This card is being verified by the operator. It will be resolved automatically — please do not resubmit it for now.',
      ERR_CARD_IN_PROGRESS_AT: 'This card is already being processed. Try again after {{time}} — no need to change cards.',
      ERR_CARD_UNDER_REVIEW_AT: 'This card is being verified by the operator. Try again after {{time}} — please do not resubmit before then.',
      ERR_OPERATOR_BUSY: 'The operator cannot process this top-up right now. Please try again in a few minutes.',
      ERR_NO_LINE: 'No line is free to take your cards right now. Your cards were not used — try again in a few minutes. This does not count as a failed attempt.',
      ERR_NO_LINE_AT: 'No line is free to take your cards right now. Your cards were not used — try again after {{time}}. This does not count as a failed attempt.',
      ERR_CARDS_ABOVE_MAX: 'Up to {{max}} card(s) per deposit on this line right now — remove some cards and try again.',
      ERR_CARDS_ABOVE_MAX_PAUSED: 'Deposits on this line are paused for now — try again later.',
      ERR_CARD_REFUSED: 'The operator refused this card. Check the code, or try another card.',
      ERR_DEPOSIT_REJECTED: 'This deposit was refused. Nothing was taken — check your codes and try again.',
      PROVIDER_UNAVAILABLE: 'The payment service did not respond. Please try again in a moment.',
      ELIGIBILITY_NOT_TND: 'TND payment methods are only available to Tunisian users.',
    },
  },
};
